<template>
  <el-dialog
    title="投递到展会/毕业展"
    :visible.sync="dialogVisible"
    width="380px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :before-close="close"
    custom-class="center_dialog"
  >
    <el-form :model="form" ref="form" label-width="18px">
      <el-form-item prop="year" label=" ">
        <el-date-picker
          v-model="form.year"
          class="input-width"
          type="year"
          placeholder="请选择毕业展年份"
          value-format="yyyy"
          @change="getEB"
        ></el-date-picker>
      </el-form-item>
      <el-form-item
        prop="exhibition"
        label=" "
        :rules="[{ required: true, message: '请选择毕业展', trigger: 'blur' }]"
      >
        <el-select
          v-model="form.exhibition"
          class="input-width"
          placeholder="请选择毕业展"
          @change="createtype"
          no-match-text="您所在的学校尚未发布该年度的毕业展"
          no-data-text="您所在的学校尚未发布该年度的毕业展"
        >
          <el-option v-for="item in EBlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="form.exhibition && form.exhibition.length && ExhibitionCategory.length"
        prop="exhibition_category"
        label=" "
        :rules="[{ required: true, message: '请选择展品分类', trigger: 'blur' }]"
      >
        <el-select
          v-model="form.exhibition_category"
          class="input-width"
          filterable
          placeholder="请选择展品分类"
        >
          <el-option
            v-for="item in ExhibitionCategory"
            :key="item.id"
            :label="item.exhibition_category"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 参加成果展会的分类 -->
      <el-form-item
        v-if="form.exhibition && form.exhibition.length && OpusCategory.length"
        prop="common_category"
        label=" "
        :rules="[{ required: true, message: '请选择展品分类', trigger: 'blur' }]"
      >
        <el-select
          v-model="form.common_category"
          class="input-width"
          filterable
          placeholder="请选择展品分类"
        >
          <el-option
            v-for="item in OpusCategory"
            :key="item.id"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        prop="teacher_ids"
        label=" "
        :rules="[{ required: true, message: '请选择指导老师', trigger: 'blur'}]"
      >
        <el-select
          v-model="form.teacher_ids"
          filterable
          multiple
          placeholder="请选择指导老师"
          class="input-width"
        >
          <el-option v-for="item in teacherList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submitForm('form')">投 递</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean
    },
    params:{
      type:Object
    }
  },
  data() {
    return {
      EBlist: [], //毕业展列表
      ExhibitionCategory: [], //展品分类
      OpusCategory: [], //成果展品分类
      teacherList: [], //指导老师列表
      form: {
        year: "",
        exhibition_category: "",
        common_category: ""
      }
    };
  },
  computed: {
    designer() {
      return this.$store.state.designer;
    }
  },
  mounted() {
    if (this.designer) {
      this.initPage();
    } else {
      this.needInfo("initPage");
    }
  },
  methods: {
    initPage(){
      this.getEB(); //根据年份查询毕业展
      this.getTeacherList(); //老师列表
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.form);
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 上传毕设
    save() {
      let teacher_ids = this.form.teacher_ids.length
        ? this.form.teacher_ids.join(",")
        : "";
      let params = Object.assign({}, this.form, {
        teacher_ids: teacher_ids,
        id:this.params.id
      });
      params.coverPath && delete params.coverPath;
      this.api.deliverOpusToGraduation(params).then(res => {
        if (res.error.err_code !== 0) return;
        this.$message.success("投递成功！");
        this.close();
      });
    },
    // 指导老师列表
    getTeacherList() {
      return new Promise(resolve => {
        this.api
          .getTeacherList({
            school: this.designer.school
          })
          .then(res => {
            if (res.error.err_code !== 0) return;
            this.teacherList = res.obj.list || [];
            resolve();
          });
      });
    },
    //根据年份查询毕业展
    getEB() {
      return new Promise(resolve => {
        let params = {
          year: this.form.year || "",
          school: this.designer.school,
          status: "IdentityCertifieStatussuccess",
          isNotHide:true
        };
        this.api.getFrontExhibitions(params).then(res => {
          if (res.error.err_code !== 0) return;
          this.EBlist = res.obj.list || [];
          resolve(res);
        });
      });
    },
    // 选择展会后生成分类（参加和未参加成果展，分类调用的接口不一样，传参也不一样）
    createtype(e) {
      let arr = this.EBlist.filter(item => {
        return item.id === e;
      });
      if (!arr[0]) return;
      if (arr[0]["is_2020"] === true) {
        // 参加成果展
        this.getDictionaries("OpusCategory", "OpusCategory");
        this.form.exhibition_category = ""; //清空未参加的数据
        this.form.common_category = ""; //清空已参加的数据
        this.ExhibitionCategory = [];
      } else {
        //未参加成果展
        this.getFrontExtends(arr[0]["code"]);
        this.form.exhibition_category = ""; //清空未参加的数据
        this.form.common_category = ""; //清空已参加的数据
        this.OpusCategory = [];
      }
    },
    /** 获取字典数据 */
    getDictionaries(typeCode, key) {
      let params = {
        typeCode: typeCode,
        pageNo: 0,
        pageSize: 999
      };
      this.api.getDictionaries(params).then(res => {
        this[key] = res.obj.list;
      });
    },
    // 展品分类
    getFrontExtends(code) {
      return new Promise(resolve => {
        this.api
          .getFrontExtends({
            type: "ExtendTypeExhibition",
            code: code
          })
          .then(res => {
            if (res.error.err_code !== 0) return;
            this.ExhibitionCategory = res.obj.list || [];
            resolve(res);
          });
      });
    },
    close() {
      this.$emit("close", {
        name: "deliver",
        dialogVisible: false
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>